import { Navigate } from "react-router-dom";

import { useOperatorMe } from "@/hooks/useOperatorMe";
import { operatorHome } from "@/lib/operatorHome";

/**
 * The `/` landing decision: which dashboard does this operator's org run?
 *
 * Rendered inside <ProtectedRoute>, which has already resolved auth and
 * membership by the time this mounts. `useOperatorMe()` is shared by every
 * caller — one key, one staleTime — so the call below is a cache read, not a
 * second request; it is here to *read* the membership, not to fetch it.
 *
 * Returning null while it resolves matches ProtectedRoute's own choice: cached
 * sessions come back in tens of milliseconds and a spinner on a route that
 * only ever redirects reads as a flash of nothing.
 *
 * An error is not a dead end. ProtectedRoute renders its own "couldn't load
 * your account" gate on a failed `me()`, so by the time this component sees
 * one it is a race, not a state the operator can be stuck in — and the leasing
 * dashboard is the safe landing either way.
 */
export function OperatorHomeRedirect() {
  const meQuery = useOperatorMe();

  if (meQuery.isLoading) return null;

  return <Navigate to={operatorHome(meQuery.data)} replace />;
}
